import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { RichText } from "../textFields";
import { shouldForwardProp } from "../utils";

type PpContainer = {
  $verticalLayout: boolean;
};

export const Container = styled("div", { shouldForwardProp })<PpContainer>`
  ${({ $verticalLayout, theme }): SerializedStyles => css`
    ${$verticalLayout &&
    css`
      ${theme.breakpoints.up("md")} {
        max-width: 66% !important;
        margin: 0 auto;
      }
    `};
  `}
`;

export const IntroSectionName = styled(Typography)`
  ${({ theme }): SerializedStyles => css`
    ${theme.cssMixins.linearGradientText};
  `}
`;

export const Paragraph = styled(RichText)`
  ${({ theme }): SerializedStyles => css`
    ${theme.cssMixins.linearGradientText};
    > p {
      ${theme.cssMixins.linearGradientText};
    }
  `}
`;
